import React from 'react'

import { AboutMe } from './components/AboutMe'
import { Contact } from './components/Contact'
import { Download } from './components/Download'
import { OfficeHours } from './components/OfficeHours'
import { Services } from './components/Services'
import { Team } from './components/Team'

interface LandingPageProps {
    className?: string
}

export const LandingPage: React.FC<LandingPageProps> = ({ className }) => {
    return (
        <div className={`${className} flex flex-col w-full justify-center items-center`}>
            <AboutMe className="max-w-container-s" />
            <Services className="max-w-container-s" />
            <OfficeHours className="max-w-container-s" />
            <Contact className="max-w-container-s" />
            <Team className="max-w-container-s" />
            <Download className="max-w-container-s" />
        </div>
    )
}
